import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import type { Student } from "../types";
import "./DraggableStudent.css";

interface Props {
  student: Student;
  isScheduled?: boolean;
}

export function DraggableStudent({ student, isScheduled }: Props) {
  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id: `student-${student.id}`,
      data: { student },
    });

  const style = {
    transform: CSS.Translate.toString(transform),
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`draggable-student ${isScheduled ? "scheduled" : ""}`}
      {...listeners}
      {...attributes}
    >
      <div className="student-avatar">
        {student.name.charAt(0).toUpperCase()}
      </div>
      <div className="student-info">
        <div className="student-name">{student.name}</div>
      </div>
    </div>
  );
}
